import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import '../styles.css';
import RestartIcon from '../../HOME/SVG/RestartIcon';
import SurrenderIcon from '../../HOME/SVG/SurrenderIcon';
import OptionsIcon from '../../HOME/SVG/OptionsIcon';
import TrophyIcon from '../../HOME/SVG/TrophyIcon';
import { REQUEST_SURRENDER_ON, REQUEST_RESET_STATS_OFF, SET_RESTART_ON, SHOW_LEADERS } from '../../HOME/REDUX/actions';
import { windowSize } from '../../HOME/utils';
import { MODE_AI } from '../../HOME/const';

const Toolbar = props => {
  const dispatch = useDispatch();
  const [dummy, setDummy] = useState(false);
  const { pt } = useSelector(state => state);
  const ai = pt.mode === MODE_AI;

  useEffect(() => {
    const forceUpdate = () => setDummy(!dummy);
    window.addEventListener('resize', forceUpdate);

    return () => {
      window.removeEventListener('resize', forceUpdate);
    };
  }, [dummy]);

  const handleSurrender = e => {
    props.hideOptions();

    if (canSurrender()) {
      if (pt.over) {
        dispatch(SET_RESTART_ON);
      } else {
        dispatch(REQUEST_SURRENDER_ON);
      }

      dispatch(REQUEST_RESET_STATS_OFF);
    }
  };

  const canSurrender = () => true;

  const handleLeaders = () => {
    props.hideOptions();
    dispatch({ type: SHOW_LEADERS });
  };

  const xmax = windowSize().x;
  const margin = Math.max(5, Math.min(10, xmax / 100));
  const styles = { button: { marginLeft: margin, marginRight: margin } };

  return (
    <div className="toolbar">
      <span className={`toolbar-button ${canSurrender() ? '' : 'toolbar-button-disabled'}`} style={styles.button} onClick={handleSurrender}>
        {ai && !pt.over ? <SurrenderIcon width="36" /> : <RestartIcon width="36" />}
      </span>
      <span className="toolbar-button" style={styles.button} onClick={handleLeaders}>
        <TrophyIcon width="36" />
      </span>
      <span className="toolbar-button" style={styles.button} onClick={props.onClickOptions}>
        <OptionsIcon width="36" id="options-button" />
      </span>
    </div>
  );
};

export default Toolbar;
